export default {
    login(state, payload) {
        state.user = payload;
        window.localStorage.setItem("user", JSON.stringify(payload));
    },
    logout(state) {
        delete state.user;
        window.localStorage.clear();
    },
    setContrato(state, contrato) {
        state.contrato = contrato;
    },
    setCliente(state, cliente) {
        state.cliente = cliente;
    },
    setPonto(state, ponto) {
        state.ponto = ponto;
    },
    setRepetidor(state, ponto) {
        state.repetidor = ponto;
    },
    setSmtp(state, smtp) {
        state.smtp = smtp;
    },
    setPlanoInternet(state, smtp) {
        state.plano_internet = smtp;
    }
};
